import BaseAnnotationLayer from "./BaseAnnotationLayer";
import {markAnnotation} from "../utils/annotations_app_utils";
import {updatePageWBCView, wbcGridSelected} from "../../../redux_actions/wbcview.action";
import {store} from "../../../helper/store";
import {get} from "../../../helper/request";
import {notNull} from "../../../utils/utils";
import {getStyleForBloodAnnotation, resetAnnotationStyle} from "../utils/map_utils";

class WBCLayer extends BaseAnnotationLayer {
    id = "WBCLayer";
    label = "WBC Layer"
    drawer = 5;
    tools = [];

    onFeatureSelect = (feature) => {
        resetAnnotationStyle();
        getStyleForBloodAnnotation(feature);
        markAnnotation(this.props.map.get('id'), feature.getProperties().annotation);
        store.dispatch(wbcGridSelected(feature.getProperties().annotation));
        const wbcGridData = store.getState().wbcViewReducer
        const activeMapId = store.getState().gammaStateReducer.activeMapId;
        const slide_id = store.getState().mapsStateReducer[activeMapId]?.slideId;

        if (notNull(slide_id)) {
            const page_size = wbcGridData.page_size;
            const anno_id = feature.getProperties().annotation.id;
            const url = `/api/get_wbc_active_page/?anno_id=${anno_id}&slide_id=${slide_id}&page_size=${page_size}&tag=${wbcGridData.tag}&confirmed=${wbcGridData.differential_confirmed}`
            get(url).then(res => store.dispatch(updatePageWBCView(res["page"])))
        }
    }
}

export default WBCLayer;